<mat-dialog-content>
    <div>{{data.message | translate}}</div>
    <div class="description">{{data.description | translate}}</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="button button--yes" [mat-dialog-close] ="true">{{'label.Yes' | translate}}</button>
    <button class="button button--no" [mat-dialog-close] ="false">{{'label.No' | translate}}</button>
</mat-dialog-actions>